import store from './index';
export const selectToken = () => store((state) => state.token);
export const selectUser = () => store((state) => state.user);
const state = store.getState();
export default {
    logout: state.logout,
    login: state.login,
    getUser: state.getUser,
    updateUser: state.updateUser,
    forgotPassword: state.forgotPassword,
    resetPassword: state.resetPassword,
    validateEmail: state.validateEmail,
    changePassword: state.changePassword,
};
